import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY } from "@/lib/site";

export default function Privacy() {
  return (
    <LegalPageLayout
      meta={{
        title: "Privacy Policy — Adviserz | Quant Core Technologies Private Limited",
        description:
          "Privacy Policy describing how Quant Core Technologies Private Limited collects, uses, stores and protects personal information submitted through the Adviserz website.",
        canonical: "https://adviserz.in/privacy",
      }}
      overline="Legal"
      title="Privacy Policy"
      intro={`${COMPANY.legalName} ("the Company", "we") operates this website under the brand name ${COMPANY.brand}. This Privacy Policy explains what information we collect, how we use it, and the choices available to you. We aim to handle personal data in a manner consistent with applicable Indian privacy and data-protection requirements.`}
      sections={[
        {
          h: "Information we collect",
          p: ["We collect only the information needed to respond to enquiries and to operate the website."],
          list: [
            "Contact details you submit voluntarily — name, email address and, where provided, phone number",
            "Information you provide in enquiry, early-access or job-application forms, including experience level and uploaded documents such as a résumé",
            "Technical information such as browser type, device type, operating system, approximate location derived from IP address, and referring pages",
            "Usage information such as pages viewed, time on page and interactions with the website",
          ],
        },
        {
          h: "How we use information",
          list: [
            "To respond to your enquiry or early-access registration",
            "To evaluate job applications where you have applied for a role",
            "To operate, secure, maintain and improve the website and platform",
            "To send you service or product updates you have requested",
            "To comply with legal, regulatory and record-keeping obligations",
          ],
          p: [
            "We do not use your contact details to provide investment advice or recommendations, and we do not sell your personal information.",
          ],
        },
        {
          h: "Cookies and analytics",
          p: [
            "The website uses cookies and similar technologies for essential functionality and for product analytics, which help us understand aggregate usage patterns. Analytics providers may process technical and usage data on our behalf.",
            "You can control or block cookies through your browser settings. Blocking some cookies may affect website functionality.",
          ],
        },
        {
          h: "Data storage and location",
          p: [
            "Information is stored on managed cloud infrastructure. Documents such as résumés are stored in access-controlled object storage. Data may be processed or stored on servers located in India or in other jurisdictions where our service providers operate, subject to appropriate safeguards.",
          ],
        },
        {
          h: "Data security",
          p: [
            "We apply reasonable technical and organisational measures, including transport encryption, access controls and restricted administrative access, to protect personal information. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
          ],
        },
        {
          h: "Third-party services",
          p: [
            "We use third-party service providers to operate the website and communicate with you, including cloud hosting, object storage, transactional email delivery and product analytics providers. These providers process data on our instructions and are expected to maintain appropriate safeguards.",
          ],
        },
        {
          h: "Your rights",
          list: [
            "Request access to the personal information we hold about you",
            "Request correction of inaccurate or incomplete information",
            "Request deletion of your information, subject to legal retention requirements",
            "Withdraw consent to further communications at any time",
          ],
          p: [`To exercise any of these rights, write to ${COMPANY.email}.`],
        },
        {
          h: "Data retention",
          p: [
            "We retain personal information only for as long as necessary to fulfil the purpose for which it was collected, or as required by applicable law. Enquiry and early-access records are retained while your interest remains active. Job-application records are retained for a reasonable period for recruitment purposes.",
          ],
        },
        {
          h: "Children",
          p: [
            "The website is not directed at children and we do not knowingly collect personal information from minors.",
          ],
        },
        {
          h: "Changes to this policy",
          p: [
            "We may update this Privacy Policy from time to time. The revised policy will be published on this page with an updated revision date.",
          ],
        },
        {
          h: "Contact",
          p: [
            `For privacy-related queries, write to ${COMPANY.email}. Postal address: ${COMPANY.address}.`,
          ],
        },
      ]}
    />
  );
}
